import React from 'react';
import { useTranslation } from 'react-i18next';
import useConfluenceArticle from '@hooks/useConfluenceArticle';

const NeedHelp = () => {
  const { t } = useTranslation('common');
  const helpArticle = useConfluenceArticle('CONT_NEED_HELP');

  return (
    <>
      <h2
        style={{
          paddingTop: '10px',
          paddingLeft: 0,
          paddingBottom: '10px',
          color: 'var(--productPrimary)',
          fontSize: '20px',
          fontWeight: '600',
          borderTop: '2px solid var(--productPrimary)'
        }}
      >
        {t('Need help?')}
      </h2>
      <div
        className="waiting-room-article"
        dangerouslySetInnerHTML={{ __html: helpArticle }}
        style={{ textDecoration: 'underline', color: 'var(--productPrimary)' }}
      />
    </>
  );
};
export default NeedHelp;
